import React, { createContext, useReducer } from 'react';

type State = {
  title: string | null;
};

enum Actions {
  SetTitle = 'setTitle',
  Reset = 'reset',
}

type Payload = {
  [Actions.SetTitle]: {
    title: string;
  };
  [Actions.Reset]: undefined;
};

const initialState: State = {
  title: null,
};

function reducer(state: State, action: Action<Payload>): State {
  switch (action.type) {
    case Actions.SetTitle:
      return {
        ...state,
        title: action.title,
      };
    case Actions.Reset:
      return initialState;
    default:
      throw new Error('Reducer case not found');
  }
}

const Context = createContext<{
  state: State;
  dispatch: React.Dispatch<Action<Payload>>;
}>({ state: initialState, dispatch: () => null });

function Provider({ children }: { children: React.ReactNode }) {
  const [state, dispatch] = useReducer(reducer, initialState);

  const value = React.useMemo(() => ({ state, dispatch }), [state]);

  return <Context.Provider value={value}>{children}</Context.Provider>;
}

export { Context, Provider, Actions };
